import { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/contexts/AuthContext';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { LoginPage } from '@/components/auth/LoginPage';
import { ShellLayout } from '@/components/shell/ShellLayout';
// 🪤 РАЗДЕЛЫ ГРУЗЯТСЯ ПО ТРЕБОВАНИЮ, А НЕ ВСЕ СРАЗУ.
//
// Раньше все три ввозились обычным образом, и в первый кусок попадало ВСЁ:
// редактор текста со своим оформлением, весь раздел задач, весь раздел
// заметок. Получалось 3,2 МБ, мегабайт сжатым, — и всё это скачивалось,
// разбиралось и запускалось ДО первого экрана. На телефоне это те самые
// десять секунд ожидания.
//
// Человек открывает приложение в одном разделе. Остальные два ему в эту
// секунду не нужны и подгрузятся, когда он туда пойдёт.
const TaskPanel = lazy(() =>
    import('@/components/panels/TaskPanel').then(m => ({ default: m.TaskPanel })));
const ChatPanel = lazy(() =>
    import('@/components/panels/ChatPanel').then(m => ({ default: m.ChatPanel })));
const NotePanel = lazy(() =>
    import('@/components/panels/NotePanel').then(m => ({ default: m.NotePanel })));

/**
 * Что показываем, пока раздел подгружается.
 *
 * 🪤 Ничего. Именно ничего: любая заставка на долю секунды читается как
 * мигание, а мигающих экранов при запуске и так было слишком много. Фон
 * совпадает с фоном приложения, поэтому переход не заметен.
 */
const ЖДЁМ = <div style={{ flex: 1, background: '#09090B' }} />;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
    mutations: { retry: 0 },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<ShellLayout />}>
              <Route path="/" element={<Navigate to="/chat" replace />} />
              <Route path="/tasks/*" element={<Suspense fallback={ЖДЁМ}><TaskPanel /></Suspense>} />
              <Route path="/chat" element={<Suspense fallback={ЖДЁМ}><ChatPanel /></Suspense>} />
              <Route path="/notes/*" element={<Suspense fallback={ЖДЁМ}><NotePanel /></Suspense>} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
    </QueryClientProvider>
  );
}
